import { Accordion } from "react-bootstrap";
import { FaChevronDown, FaEllipsisH } from "react-icons/fa";
import { IoMdInformationCircleOutline } from "react-icons/io";

/**
 * AccordianCard Component
 *
 * Reusable accordion card component with collapsible content sections.
 */
const AccordianCard = ({
  title,
  className,
  style,
  activeKey,
  infoText,
  children,
}) => {
  return (
    <Accordion className={className} style={style} defaultActiveKey={activeKey}>
      <Accordion.Item eventKey={activeKey}>
        <Accordion.Header className="companycardheader overflowhidden">
          <div className="companyarrowicon">
            <FaChevronDown />
          </div>

          <div className="companytitlecard">{title}</div>

          <div className="companyellipsisicon">
            <FaEllipsisH />
          </div>
        </Accordion.Header>

        <Accordion.Body
          className="ideacheckeraccordioncardbody overflowhidden"
          id="companyinformation"
        >
          {infoText && (
            <div>
              <IoMdInformationCircleOutline />
              <span className="info-text">{infoText}</span>
            </div>
          )}

          <div>{children}</div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default AccordianCard;
